import { render, staticRenderFns } from "./TalkThreadOverview.vue?vue&type=template&id=3068fd90&"
import script from "./TalkThreadOverview.vue?vue&type=script&lang=ts&"
export * from "./TalkThreadOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports